export default function handleSearch() {
    const searchTrigger = document.querySelector('.search-btn')
    const searchPanel = document.querySelector('.header__search')

    if (searchPanel && searchTrigger) {
    const searchInput = searchPanel.querySelector('#header-search')
    const searchClose = document.querySelector('.header__search-close')

    searchTrigger.addEventListener('click', function() {
        searchPanel.classList.remove('hidden')
        searchInput.focus()
    })

    searchClose.addEventListener('click', function() {
        searchPanel.classList.add('hidden')
        searchTrigger.focus()
    })
    }
}
